import { type ButtonProps as MUIButtonProps } from "@mui/material/Button";
import { FC } from "react";
import * as Styled from "./ButtonWithIconRight.styled";

export type ButtonWithIconRightProps = MUIButtonProps & {
    title: string;
    subtitle?: string;
    icon?: React.ReactNode;
};

export const ButtonWithIconRight: FC<ButtonWithIconRightProps> = ({ title, subtitle, icon, ...rest }) => {
    return (
        <Styled.ButtonWithIconRightRoot
            endIcon={icon ? <Styled.RightIconWrapper>{icon}</Styled.RightIconWrapper> : undefined}
            {...rest}
        >
            <Styled.ButtonContent>
                <Styled.ButtonTitle>{title}</Styled.ButtonTitle>
                {subtitle ? <Styled.ButtonSubtitle>{subtitle}</Styled.ButtonSubtitle> : null}
            </Styled.ButtonContent>
        </Styled.ButtonWithIconRightRoot>
    );
};
